import { Checkbox, CheckboxProps } from "@mui/material";
import React from "react";
import {
  FieldValues,
  useController,
  UseControllerProps,
} from "react-hook-form";

export type CheckboxInputProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<CheckboxProps, "value" | "defaultValue">;

export function CheckboxInput<T extends FieldValues>({
  name,
  control,
  defaultValue,
  rules,
  shouldUnregister,
  ...props
}: CheckboxInputProps<T>) {
  const {
    field: { value, onChange: fieldOnChange, ...field },
    fieldState,
  } = useController<T>({
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
  });

  return (
    <Checkbox
      checked={value}
      onChange={(e) => {
        fieldOnChange(e);
      }}
      defaultChecked={defaultValue}
      {...field}
      {...props}
    />
  );
}

export default CheckboxInput;
